import { gql } from 'graphql-tag'

import { FRAGMENT_AVATAR_USER } from '@/components/Worlds/UI/Avatar/Avatar.hasura'

export const SUBSCRIPTION_MESSAGE_EMBED_V1_ASSESSMENT_ASSESSMENT_MESSAGE = gql`
  subscription MessageEmbedV1AssessmentAssessmentMessage($id: Int!) {
    assessment (where: { id: { _eq: $id } }) {
      id
      title
      description
      form_blocks

      assessment_submissions {
        id
        responses
        user {
          id
          ...AvatarUser
        }
      }
    }
  }

  ${FRAGMENT_AVATAR_USER}
`
